export const oldMFDseries: string[] = [
  "trulyOffFaultMFD.all",
  "InversionTargetMFDs.targetOnFaultSupraSeisMFD_SansTVZ",
  "InversionTargetMFDs.targetOnFaultSupraSeisMFD_TVZ",
  "totalSubSeismoOnFaultMFD",
  "solutionMFD_rateWeighted",
];

export const v1MFDseries: string[] = [
  "trulyOffFaultMFD.all",
  "targetOnFaultSupraSeisMFD_SansTVZ",
  "targetOnFaultSupraSeisMFD_TVZ",
  "totalSubSeismoOnFaultMFD",
  "solutionMFD_rateWeighted",
];

export const subductionSeries: string[] = ["targetOnFaultSupraSeisMFD", "solutionMFD_rateWeighted"];

export const displayNames = {
  solutionMFD: "Solution MFD",
  solutionMFD_rateWeighted: "Solution MFD - rate weighted",
  totalTargetGR: "Total Target GR",
  trulyOffFaultMFD: "Truly Off Fault MFD",
  targetOnFaultSupraSeisMFD: "Target On Fault Supra Seis MFD",
  totalSubSeismoOnFaultMFD: "Total Subseismo On Fault MFD",
  "totalTargetGR.all": "Total Target GR - All",
  "InversionTargetMFDs.totalTargetGR_SansTVZ": "Total Target GR - SansTVZ",
  "InversionTargetMFDs.totalTargetGR_TVZ": "Total Target GR - TVZ",
  "trulyOffFaultMFD.all": "Truly Off Fault MFD - All",
  "InversionTargetMFDs.trulyOffFaultMFD_SansTVZ.": "Truly Off Fault MFD - SansTVZ",
  "InversionTargetMFDs.trulyOffFaultMFD_TVZ.": "Truly Off Fault MFD - TVZ",
  "targetOnFaultSupraSeisMFD.all": "Target On Fault Supra Seis MFD - All",
  "InversionTargetMFDs.targetOnFaultSupraSeisMFD_SansTVZ": "Target On Fault Supra Seis MFD - SansTVZ",
  "InversionTargetMFDs.targetOnFaultSupraSeisMFD_TVZ": "Target On Fault Supra Seis MFD - TVZ",
  targetOnFaultSupraSeisMFD_SansTVZ: "Target On Fault Supra Seis MFD - SansTVZ",
  targetOnFaultSupraSeisMFD_TVZ: "Target On Fault Supra Seis MFD - TVZ",
  "totalSubSeismoOnFaultMFD.all": "Total Subseismo On Fault MFD - All",
  "InversionTargetMFDs.totalSubSeismoOnFaultMFD_SansTVZ.": "Total Subseismo On Fault MFD - SansTVZ",
  "InversionTargetMFDs.totalSubSeismoOnFaultMFD_TVZ.": "Total Subseismo On Fault MFD - TVZ",
};

export const seriesNameToColour = (value: string): string => {
  if (value.includes("totalTargetGR")) {
    return "orange";
  }
  if (value.includes("trulyOffFaultMFD")) {
    return "steelblue";
  }
  if (value.includes("targetOnFaultSupraSeisMFD")) {
    return "lightgray";
  }
  if (value.includes("totalSubSeismoOnFaultMFD")) {
    return "black";
  }
  if (value.includes("solutionMFD")) {
    return "red";
  }
  return "yellow";
};
